import { useState } from "react";
import { getCldImage, getBlurImage } from "../utils/cloudinary";

export const ProductImage = ({ publicId, alt, className }) => {
  const [loaded, setLoaded] = useState(false);

  const blurSrc = getBlurImage(publicId, 800);
  const fullSrc = getCldImage(publicId, 800);

  return (
  <div className={`relative w-full h-full flex items-center justify-center ${className}`}>
    
    {/* Blur */}
    <img
      src={blurSrc}
      alt={alt}
      className={`max-w-full max-h-full object-contain transition-opacity duration-500 ${
        loaded ? "opacity-0 absolute" : "opacity-100"
      }`}
    />

    {/* Main */}
    <img
      src={fullSrc}
      alt={alt}
      loading="lazy"
      onLoad={() => setLoaded(true)}
      className={`max-w-full max-h-full object-contain transition-all duration-700 ${
        loaded ? "opacity-100" : "opacity-0"
      }`}
    />
  </div>
);
};